import { render } from "./CardholderNameLabel.vue?vue&type=template&id=f87b0608&lang=pug"
import script from "./CardholderNameLabel.vue?vue&type=script&lang=js"
export * from "./CardholderNameLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__